import { Database, Inbox, Server, ShieldAlert } from "lucide-react";

export const EmailBlacklistsKeyFindings = () => {
  const findings = [
    {
      icon: <Database className="w-5 h-5" />,
      title: "A blacklist is a database, not a gatekeeper",
      description:
        "A blacklist is a public database of domains or IP addresses that receiving mail servers may choose to query. The list operators block nothing themselves. Every blocking decision belongs to the receiving system that decided to consult the list.",
    },
    {
      icon: <Inbox className="w-5 h-5" />,
      title: "Gmail and Microsoft do not consult public blacklists",
      description:
        "The two largest mailbox providers do not use public blacklists for inbox placement. They run internal reputation systems built on their own engagement signals and complaint data, which is why a listing can appear while your delivery to those providers stays unchanged.",
    },
    {
      icon: <Server className="w-5 h-5" />,
      title: "Public lists mainly reach corporate gateways",
      description:
        "Public blacklists mostly affect recipients sitting behind corporate gateway filters, such as SpamAssassin based systems, Proofpoint, Mimecast and Barracuda. Those gateways query lists during filtering and score or reject accordingly.",
    },
    {
      icon: <ShieldAlert className="w-5 h-5" />,
      title: "Spamhaus is the real exception",
      description:
        "Spamhaus has genuine global reach. It is consulted by mail systems worldwide, and a listing there causes immediate delivery failures rather than a small scoring penalty. It deserves a different level of urgency than every other list.",
    },
  ];

  return (
    <section className="py-10 sm:py-12">
      <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-8 text-center">
        Key findings
      </h2>

      <div className="grid sm:grid-cols-2 gap-4">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-5 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary flex-shrink-0">
                {finding.icon}
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1.5">{finding.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {finding.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};